import React, { createContext } from 'react';
import HeaderSectionThemeDefault from './configs/HeaderSection.config';
import TextSectionThemeDefault from './configs/TextSection.config';
import ImageSectionThemeDefault from './configs/ImageSection.config';
import CardSectionThemeDefault from './configs/CardSection.config';
import { ContentCardMegaThemeDefault, ContentCardMiniThemeDefault, ContentCardRegularThemeDefault } from './configs/ContentCard.config';
import { applyCssUnitsToStyleSettings, deleteEmptyOrNullKeys, mergeConfigs, transformStyleSettings } from './ThemeContext.utils';
import CartUpsellTheme from './configs/CartUpsell.config';
var themeMap = {
    HEADER_SECTION: HeaderSectionThemeDefault,
    TEXT_SECTION: TextSectionThemeDefault,
    IMAGE_SECTION: ImageSectionThemeDefault,
    CARD_SECTION: CardSectionThemeDefault,
    CONTENT_CARD_MEGA: ContentCardMegaThemeDefault,
    CONTENT_CARD_MINI: ContentCardMiniThemeDefault,
    CONTENT_CARD_REGULAR: ContentCardRegularThemeDefault,
    CARD_UPSELL: CartUpsellTheme
};
export var ThemeContext = createContext({});
/**
 * `ThemeProvider` is a context for Content System components.
 * This context is used to store and share theme settings.
 *
 * @component
 * @param {Object} props - Properties that define the `ThemeProvider`.
 * @param {Object} props.config - Configuration object for the theme.
 * @param {ReactNode} props.children - Child components to be wrapped by the theme provider.
 * @param {string} props.sectionType - The type of section to determine the default theme.
 * @returns {JSX.Element} Theme provider component.
 */
var ThemeProvider = function (_a) {
    var config = _a.config, children = _a.children, sectionType = _a.sectionType;
    var defaultTheme = themeMap[sectionType || ''] || {};
    var context = defaultTheme;
    // If a config object is provided
    if (config && config.length > 0) {
        // Remove empty or null keys from settings
        var sanitizedConfig = config.map(function (el) { return deleteEmptyOrNullKeys(el); });
        // Convert the values to CSS units without mutating the original config
        var cssUnitConfig = applyCssUnitsToStyleSettings(sanitizedConfig);
        // Re-format the config object to match the default theme structure
        var transformedConfig = transformStyleSettings(cssUnitConfig);
        // Merge the default theme with the transformed config object
        context = mergeConfigs(defaultTheme, transformedConfig);
    }
    return (React.createElement(ThemeContext.Provider, { value: context }, children));
};
export default ThemeProvider;
